import { BaseEntity } from '@base-entities';
import { IBaseTransformerRepository } from '@base-repositories';

import { DashboardTransformer } from '../transformers';

export function makeDashboardTransformer<E extends BaseEntity = BaseEntity>(): IBaseTransformerRepository<E> {
  return new DashboardTransformer<E>();
}
